import { render, staticRenderFns } from "./selectPrize.vue?vue&type=template&id=7c4fe646&scoped=true"
import script from "./selectPrize.vue?vue&type=script&lang=js"
export * from "./selectPrize.vue?vue&type=script&lang=js"
import style0 from "./selectPrize.vue?vue&type=style&index=0&id=7c4fe646&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4fe646",
  null
  
)

export default component.exports